import Axios from "axios";
import {
    SET_HRM_HOD_LIST,
    UNSET_HRM_HOD_LIST,
  } from "@/store/mutation-types";
import { saveUpdateHrmHOD, getHrmHODList } from "@/store/api";
// initial state
const state = {
  getHrmHODList: [],
};

const getters = {
  getHrmHODList(state) {
    return state.getHrmHODList;
  },
};

const mutations = {
  [SET_HRM_HOD_LIST](state, data) {
    state.getHrmHODList = data;
  },
  [UNSET_HRM_HOD_LIST](state) {
    state.getHrmHODList = [];
  },

};

const actions = {

  saveUpdateHrmHOD({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateHrmHOD, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmHODList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmHODList, data)
        .then(function (response) {
          commit('SET_HRM_HOD_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_HOD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
